// extracted by mini-css-extract-plugin
export default {"container":"ListItem_container__b4baP","name":"ListItem_name__Dj2ZU","cpf":"ListItem_cpf__cRL6u"};